import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";

interface MobileNavBarTabsProps {
  handleClick: () => void;
}

export const MobileNavBarTabs: React.FC<MobileNavBarTabsProps> = ({
  handleClick,
}) => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="mobile-nav-bar__tabs">
      {isAuthenticated && (
        <>
          <MobileNavBarTab
            path="/home"
            label="Home"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/chat"
            label="Chat"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/calendar"
            label="Calendar"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/connect"
            label="Connect"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/workouts"
            label="Workouts"
            handleClick={handleClick}
          />
        </>
      )}
      <MobileNavBarTab
        path="/profile"
        label="Profile"
        handleClick={handleClick}
      />
    </div>
  );
};
